import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

export default function Logout() {
    const navigate = useNavigate();

    useEffect(() => {
        // Clear all user data from localStorage
        const clearUserData = () => {
            localStorage.removeItem('user_code');
            localStorage.removeItem('full_name');
            localStorage.removeItem('email_id');
            localStorage.removeItem('mobile_number');
            localStorage.removeItem('user_type');
            localStorage.removeItem('access_token');
            
            // Clear any other session data
            localStorage.removeItem('selectedMemberId');
            localStorage.removeItem('sessionStart');
            sessionStorage.clear();
        };

        // Execute logout
        try {
            clearUserData();
            
            // Show success message
            Swal.fire({
                title: 'Logged Out',
                text: 'You have been successfully logged out',
                icon: 'success',
                confirmButtonText: 'OK',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(() => {
                // Redirect to login page
                // navigate('/login', { replace: true });
                window.location.href = '/login';
            });
        } catch (error) {
            console.error('Logout error:', error);
            // Still redirect even if there's an error
            navigate('/login', { replace: true });
        }
    }, [navigate]);

    return (
        <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
            <div className="text-center">
                <div className="spinner-border text-primary mb-3" role="status">
                    <span className="visually-hidden">Logging out...</span>
                </div>
                <p className="text-muted">Logging you out...</p>
            </div>
        </div>
    );
}
